// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"4ad78ef0","191":"f9a71f0e","270":"a6c89c9f","335":"b45e1edb","404":"e2ced1ed","455":"6e379d0c","465":"fe67ff59","667":"a1e06d26","767":"75dadf27","889":"699916c0","977":"2f9ca617"}[chunkId] + ".chunk.js";
};